import { render, staticRenderFns } from "./bandaoti.vue?vue&type=template&id=2c20d768&scoped=true"
import script from "./bandaoti.vue?vue&type=script&lang=js"
export * from "./bandaoti.vue?vue&type=script&lang=js"
import style0 from "./bandaoti.vue?vue&type=style&index=0&id=2c20d768&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20d768",
  null
  
)

export default component.exports